import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class DistrictsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    console.log(
      "DistrictsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let query = null;
    if (params.filter.seasonCode) {
      query = query || {};
      query.seasonCodes = params.filter.seasonCode;
    }
    if (params.filter.sportCode) {
      query = query || {};
      query.sportCodes = params.filter.sportCode;
    }

    let queryString = "";
    if (query || params.pagination.perPage) {
      queryString += "(";
      if (query)
        queryString +=
          "query:[" +
          JSON.stringify(query).replace(/"(\w+)"\s*:/g, "$1:") +
          "]";
      if (params.pagination.perPage)
        queryString +=
          " offset:" +
          (params.pagination.page - 1) * params.pagination.perPage +
          " limit:" +
          params.pagination.perPage;
      queryString += ")";
    }
    console.log("DistrictsDataProvider.getList():queryString:", queryString);
    const GET = gql`
          query {
            DistrictsSearch${queryString} {
              offset
              limit
              total
              data {
                id
                seasonCode
                leagueCode
                sportCode
                conferenceCode
                divisionCode
                regionCode
                districtCode
                label
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return response.data.DistrictsSearch;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getOne(resource, params) {
    console.log(
      "DistrictsDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            DistrictByID(id:"${params.id}") {
              id
              seasonCode
              sportCode
              leagueCode
              conferenceCode
              divisionCode
              regionCode
              districtCode
              label
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.DistrictByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async update(resource, params) {
    console.log(
      "DistrictsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.sportCode;
    delete objectInfo.seasonCode;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateDistrict(${objectString}) {
              id
              seasonCode
              sportCode
              leagueCode
              conferenceCode
              divisionCode
              regionCode
              districtCode
              label
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateDistrict };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    console.log(
      "DistrictsDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    var objectString = JSON.stringify(params.data).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreateDistrict(${objectString}) {
              id
              seasonCode
              sportCode
              leagueCode
              conferenceCode
              divisionCode
              regionCode
              districtCode
              label
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateDistrict };
  }

  async delete(resource, params) {
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteDistrictByID(${infoString})
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }
}

export default DistrictsDataProvider;
